import { render } from "./BaseFormInput.vue?vue&type=template&id=ffa19a8c"
import script from "./BaseFormInput.vue?vue&type=script&lang=js"
export * from "./BaseFormInput.vue?vue&type=script&lang=js"

import exportComponent from "/home/projects/cc-gastro/htdocs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/BaseFormInput.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ffa19a8c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ffa19a8c', __exports__)) {
    console.log('reload')
    api.reload('ffa19a8c', __exports__)
  }
  
  module.hot.accept("./BaseFormInput.vue?vue&type=template&id=ffa19a8c", () => {
    console.log('re-render')
    api.rerender('ffa19a8c', render)
  })

}


export default __exports__